export const statusStyles = {
    draft: { label: "작성 중", color: "gray", icon: "📝", description: "결의서를 작성 중입니다." },
    submitted: { label: "제출 완료", color: "blue", icon: "📤", description: "결의서가 제출되었습니다." },
    received: { label: "경리과 접수", color: "orange", icon: "📥", description: "결의서가 경리과에 접수되었습니다." },
    processing: { label: "집행 중", color: "green", icon: "⚙️", description: "결의서가 집행 중입니다." },
    completed: { label: "집행 완료", color: "black", icon: "✅", description: "결의서가 완료되었습니다." }
  };
  